/* eslint-disable max-len */

import { css } from '@emotion/react';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';

export const renderBackgroundColor = (severity) => {
  if (severity === 'neutral') return '#f2f2fd';
  if (severity === 'success') return '#d6f3e2';
  if (severity === 'alert') return '#fdedee';
  return '';
};

export const renderIconColor = (severity) => {
  if (severity === 'neutral') return '#4a50dd';
  if (severity === 'success') return '#008556';
  if (severity === 'alert') return '#de1c22';
  return null;
};

export const renderSeverity = (severity) => {
  if (severity === 'neutral') return 'info';
  if (severity === 'success') return 'success';
  if (severity === 'alert') return 'error';
  return null;
};

const iconColorCss = (severity) => css`
  color: ${renderIconColor(severity)};
`;

export const announcementIcons = {
  neutral: <InfoIcon css={iconColorCss('neutral')} />,
  success: <CheckCircleIcon css={iconColorCss('success')} />,
  alert: <ErrorIcon css={iconColorCss('alert')} />,
};
